module.exports = __webpack_public_path__ + "7f08f0f84468d6a34e91dc3687b17206.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/futura_book/futura_book.eot
// module id = 313
// module chunks = 0